"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _AccountSelectPage = _interopRequireDefault(require("./AccountSelectPage"));

var _PaymentMethodPage = _interopRequireDefault(require("./PaymentMethodPage"));

var _SummaryPage = _interopRequireDefault(require("./SummaryPage"));

var _ReceiptPage = _interopRequireDefault(require("./ReceiptPage"));

var _AppStore = _interopRequireDefault(require("../Store/AppStore"));

var _mobxReact = require("mobx-react");

var _reactRouterDom = require("react-router-dom");

var _tsysSecureEntry = require("tsys-secure-entry");

var _TSEPFields = _interopRequireDefault(require("./TSEP/TSEPFields"));

var _CardholderInfo = _interopRequireDefault(require("./TSEP/CardholderInfo"));

var _core = require("@material-ui/core");

require("../App.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var MainForm = function MainForm(_ref) {
  var patientPortalUserId = _ref.patientPortalUserId,
      basename = _ref.basename;

  var _useState = (0, _react.useState)(true),
      _useState2 = _slicedToArray(_useState, 2),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var _useTSEPScripts = (0, _tsysSecureEntry.useTSEPScripts)(_AppStore.default.enteredCardInfo),
      _useTSEPScripts2 = _slicedToArray(_useTSEPScripts, 1),
      fieldProps = _useTSEPScripts2[0];

  (0, _react.useEffect)(function () {
    var loadData = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _AppStore.default.setPortalUserId(patientPortalUserId);

                _context.next = 3;
                return _AppStore.default.loadAccounts();

              case 3:
                setLoading(false);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function loadData() {
        return _ref2.apply(this, arguments);
      };
    }();

    loadData();
  }, [patientPortalUserId]);

  if (loading) {
    return /*#__PURE__*/_react.default.createElement(_core.Backdrop, {
      open: true
    }, /*#__PURE__*/_react.default.createElement(_core.CircularProgress, {
      size: 100
    }));
  }

  return /*#__PURE__*/_react.default.createElement(_reactRouterDom.BrowserRouter, {
    basename: basename
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "OnlinePayments"
  }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Switch, null, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    path: "/paymentMethod"
  }, /*#__PURE__*/_react.default.createElement(_PaymentMethodPage.default, null)), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    path: "/cardEntry"
  }, /*#__PURE__*/_react.default.createElement(_TSEPFields.default, _extends({}, fieldProps, {
    tsepNeedsLoaded: _AppStore.default.tsepNeedsLoaded
  }))), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    path: "/cardholder"
  }, /*#__PURE__*/_react.default.createElement(_CardholderInfo.default, fieldProps)), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    path: "/summary"
  }, /*#__PURE__*/_react.default.createElement(_SummaryPage.default, null)), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    path: "/receipt"
  }, /*#__PURE__*/_react.default.createElement(_ReceiptPage.default, null)), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    path: "/accountSelect"
  }, /*#__PURE__*/_react.default.createElement(_AccountSelectPage.default, null)), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Redirect, {
    from: "/",
    to: "accountSelect"
  }))));
};

MainForm.propTypes = {
  patientPortalUserId: _propTypes.default.number.isRequired,
  basename: _propTypes.default.string.isRequired
};

var _default = (0, _mobxReact.observer)(MainForm);

exports.default = _default;